
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 24.5C40 33.06 33.06 40 24.5 40 15.94 40 9 33.06 9 24.5 9 15.94 15.94 9 24.5 9 33.06 9 40 15.94 40 24.5zm-17.293 8.207l11.5-11.5a1 1 0 000-1.414l-1.414-1.414a1 1 0 00-1.414 0L22 27.757l-4.379-4.378a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l6.5 6.5a1 1 0 001.414 0z","fill":"#535353"}})])
          )
        }
      }
    